export const defaultChecklistsObj = {
  checklistsInfo: [],
  questions: [],
};
